import React from 'react'
import { Menu } from 'antd'
import { Link } from 'react-router-dom'

import CustomScrollbars from 'util/CustomScrollbars'
import SidebarLogo from './SidebarLogo'
import IntlMessages from '../../util/IntlMessages'

const SidebarContent = ({ memberType }) => {
	return (
		<>
			<SidebarLogo />
			<div className='gx-sidebar-content'>
				<CustomScrollbars className='gx-layout-sider-scrollbar'>
					<Menu
						// defaultOpenKeys={[defaultOpenKeys]}
						// selectedKeys={[selectedKeys]}
						theme={'lite'}
						mode='inline'
					>
						{/* <Menu.Item key='sample'>
						<Link style={{ color: '#FF8000' }} to='/sample'>
							<span><IntlMessages id='sidebar.samplePage' /></span>
						</Link>
					</Menu.Item>

					<Menu.Item key='sample2'>
						<Link style={{ color: '#FF8000' }} to='/sample2'>
							<span><IntlMessages id='sidebar.samplePage' /></span>
						</Link>
					</Menu.Item> */}


						{memberType === 'user' ? (
							<>
								<Menu.Item key='userProfile'>
									<Link style={{ color: '#FF8000' }} to='/user'>
										<IntlMessages id='nav.profile' />
									</Link>
								</Menu.Item>
								<Menu.Item key='userDonations'>
									<Link style={{ color: '#FF8000' }} to='/user/donations'>
										<IntlMessages id='nav.donations' />
									</Link>
								</Menu.Item>
								<Menu.Item key='userSubscriptions'>
									<Link style={{ color: '#FF8000' }} to='/user/subscriptions'>
										<IntlMessages id='nav.subscriptions' />
									</Link>
								</Menu.Item>
							</>
						) : null}

						{memberType === 'admin' ? (
							<>
								<Menu.Item key='dashboard'>
									<Link style={{ color: '#FF8000' }} to='/admin'>
										<IntlMessages id='nav.dashboard' />
									</Link>
								</Menu.Item>
								<Menu.Item key='admin'>
									<Link to='/admin/management'>
										<IntlMessages id='nav.admin' />
									</Link>
								</Menu.Item>
								<Menu.Item key='donors'>
									<Link style={{ color: '#FF8000' }} to='/admin/donors'>
										<IntlMessages id='nav.donors' />
									</Link>
								</Menu.Item>
								<Menu.Item key='news'>
									<Link style={{ color: '#FF8000' }} to='/admin/news'>
										<IntlMessages id='nav.news' />
									</Link>
								</Menu.Item>
							</>
						) : null}
					</Menu>
				</CustomScrollbars>
			</div>
		</>
	)
}

SidebarContent.propTypes = {}

export default SidebarContent
